import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  getById(id: number) {
    return wrapEndpoint(() =>
      client.GET('/patient-note/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  list(options?: ApiSchemas['ListPatientNoteDto']) {
    return wrapEndpoint(() =>
      client.GET('/patient-note', {
        params: {
          query: options,
        },
      }),
    )
  },
  create(body: ApiSchemas['CreatePatientNoteDto']) {
    return wrapEndpoint(() =>
      client.POST('/patient-note', {
        body,
      }),
    )
  },
  updateById(id: number, body: ApiSchemas['UpdatePatientNoteDto']) {
    return client.PUT('/patient-note/{id}', {
      params: {
        path: {
          id,
        },
      },
      body,
    })
  },
  deleteById(id: number) {
    return client.DELETE('/patient-note/{id}', {
      params: {
        path: {
          id,
        },
      },
    })
  },
}
